/**
 * eID (elektronska lična karta) OAuth2/OIDC konfiguracija.
 * Konstante se učitavaju iz environment varijabli (.env.development / .env.production)
 * i koriste u AuthService UserManager podešavanjima.
 */

/**
 * eID OAuth2 server URL (Authority endpoint).
 * Development: https://prijava.test.eid.gov.rs/oauth2/oidcdiscovery/
 * Production: https://prijava.eid.gov.rs/oauth2/oidcdiscovery/
 * @type {string|undefined}
 */
export const STS_AUTHORITY = process.env.REACT_APP_STS_AUTHORITY;

/**
 * Registrovan CLIENT_ID aplikacije (dobija se registracijom na eID portalu).
 * @type {string|undefined}
 */
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

/**
 * OAuth2 scope — traženi podaci od korisnika (openid, profile, name, id, gender, residence, mail).
 * @type {string|undefined}
 */
export const CLIENT_SCOPE = process.env.REACT_APP_CLIENT_SCOPE;

/**
 * Korenski URL aplikacije za OIDC redirect URI-je.
 * Automatski se određuje iz `window.location.origin` — radi na localhost-u i produkciji bez hardkodiranja.
 * @type {string}
 */
export const CLIENT_ROOT = window.location.origin + "/";

/**
 * Napomene za konfiguraciju:
 * - Development: .env.development; produkcija: .env.production
 * - CLIENT_ID mora biti registrovan na eID portalu
 * - Whitelist redirect URI-ji: {CLIENT_ROOT}/signin-oidc, {CLIENT_ROOT}/signout-callback-oidc, {CLIENT_ROOT}/silent-renew.html
 */
